import ImageSlider from "./ImageSlider";
import { nxopsSlides } from "../data/nxops-slides";

export default function NxopsSlider(props) {
  const { slides, ...rest } = props || {};
  return (
    <ImageSlider
      slides={Array.isArray(slides) && slides.length > 0 ? slides : nxopsSlides}
      containerClass="max-w-6xl mx-auto"
      defaultLayout="split"
      {...rest}
    />
  );
}
